function getState(zipcode) {
  // Ensure param is a string to prevent unpredictable parsing results
  if (typeof zipcode !== 'string') {
    throw new Error(
      "'Must pass the zipcode as a string. -- Otherwise leading zeros could cause your zip code to be parsed outside base 10.'"
    )
  }

  // Ensure you don't parse codes that start with 0 as octal values
  const zip = parseInt(zipcode, 10)
  const state = window.STATES_LIST_LOOKUP.find(s => s.min <= zip && s.max >= zip)

  return { code: state?.code, long: state?.long }
}

class ShippingCalc extends HTMLElement {
  constructor() {
    super()
    this.totalPrice = this.getAttribute('totalPrice')
    this.total = (+this.totalPrice || 0) / 100
    this.zipcodeForm = document.querySelector('[data-zipcode-form]')
    this.zipcodeFormInput = document.querySelector('[name="zipcode"]')
    this.urlZipcode = new URL(window.location).searchParams.get('zipcode')
    this.storageZipcode = window.localStorage.getItem('customerZip')
    this.customerZipcode = this.urlZipcode || this.storageZipcode || null
    this.shippingMessage = this.querySelector('[data-shipping-price]')

    this.zipcodeForm.addEventListener('submit', event => {
      event.preventDefault()
      if (!this.zipcodeFormInput.value) return
      this.getRatesAndUpdateShippingPrice(this.zipcodeFormInput.value)
    })

    this.init()
  }

  init() {
    if (!this.customerZipcode) return
    this.getRatesAndUpdateShippingPrice(this.customerZipcode)
  }

  getRatesAndUpdateShippingPrice(zipCode) {
    const state = getState(zipCode.toString())
    const rate = this.getShippingRates(state.code)
    this.updateShippingRate(rate)
  }

  getShippingRates(stateCode) {
    const rates = Object.entries(window.SHIPPING_RATES)

    const data = rates.find(rate => {
      const [location] = rate
      return location.includes(stateCode)
    })

    if (!data) return

    const [, details] = data

    if (details.flatRate) {
      return details.flatRate
    }

    const priceOption = details.options.find(el => {
      return this.total >= el.min && (this.total <= el.max || !el.max)
    })

    return priceOption?.price || 'Free Shipping'
  }

  updateShippingRate(rate) {
    this.shippingMessage.textContent = rate ? (typeof rate === 'string' ? rate : `$${rate}`) : '--'
  }
}

customElements.define('shipping-calc', ShippingCalc)
